import { useContext, useState } from "react"
import { Form, Button } from 'react-bootstrap'
import { useNavigate } from "react-router-dom"
import './LogInForm.css'

import authService from '../../services/auth.services'

import { MessageContext } from './../../contexts/userMessage.context'
import { AuthContext } from "../../contexts/auth.context"


const LogInForm = ({ fireFinalActions }) => {

    const [loginData, setLoginData] = useState({
        email: '',
        password: ''
    })

    const { setShowMessage } = useContext(MessageContext)
    const { storeToken, authenticateUser } = useContext(AuthContext)
    const navigate = useNavigate()

    const handleInputChange = e => {
        const { value, name } = e.target
        setLoginData({ ...loginData, [name]: value })
    }

    const handleSubmit = e => {
        e.preventDefault()

        authService
            .login(loginData)
            .then(({ data }) => {
                storeToken(data.authToken)
                authenticateUser()
                setShowMessage({ show: true, title: `Welcome!`, text: `U are login!` })
                fireFinalActions()
                navigate('/games-list')
            })
            .catch(err => console.log(err))
    }

    const { email, password } = loginData

    return (
        <>
            <div className='button-86'>
                <Form onSubmit={handleSubmit}>

                    <Form.Group className="mb-3" controlId="email">
                        <Form.Label></Form.Label>
                        <Form.Control type="text" value={email} onChange={handleInputChange} name="email" placeholder="Email" />
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="password">
                        <Form.Label></Form.Label>
                        <Form.Control type="password" value={password} onChange={handleInputChange} name="password" placeholder="Password" />
                    </Form.Group>

                    <div className="d-grid">
                        <Button className="button-86" type="submit">Log In</Button>
                    </div>
                </Form>

            </div>

        </>
    )
}

export default LogInForm